//!#system	

<template>
    <v-container fluid fill-height>
        <v-layout justify-center align-center column pa-5>
            <div class="display-3 font-weight-black white--text text-xs-center mb-3">{{appHome.heroLine}}</div>
            <div class="display-1 font-weight-light white--text text-xs-center">{{appHome.secondLine}}</div>
            <v-btn fab class="mt-5 blue-grey darken-4" to="/sign-in">
            <v-icon large color="white">mdi-login</v-icon>
            </v-btn>
        </v-layout>
    </v-container>
</template>

<script>

export default {
    name: 'HomeHero',
    data() {
        return {
            appHome: this.$store.state.app.appHome
        }
    }
    
};
</script>

<style scoped>
</style>